var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
const BASE_PATH = "/aviso/personMerge";
export default class PersonMergeService {
    /**
     * Determines if a person is merge-able
     *
     * @param {string} personId - The ID of the person who is
     * being checked for merge-ability
     * @returns {Promise<boolean>} - boolean indicating if person is merge-able
     */
    static isMergeable(personId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getSingleResponse(BASE_PATH + "/findUnmergeablePeople", {
                personIds: [personId],
            });
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            return response.length <= 0;
        });
    }
    /**
     * Merge a person with another person
     *
     * @param {string} sourcePersonId - The ID of the person who will be deleted
     * @param {string} survivorPersonId - The ID of the person who will survive
     * */
    static mergePeople(sourcePersonId, survivorPersonId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_PATH + "/mergeSingle", {
                source: sourcePersonId,
                target: survivorPersonId,
            });
        });
    }
    static deletePerson(personId) {
        return FetchService.deleteSingleResponse(BASE_PATH + "/deleteBulk", {
            personIds: [personId],
        });
    }
    static mergeBulk(personIdList) {
        return FetchService.postSingleResponse(BASE_PATH + "/mergeBulk", {
            merges: personIdList,
        });
    }
    static autoMerge(ruleSetId) {
        return FetchService.postSingleResponse(BASE_PATH + "/autoMerge", {
            ruleSetId,
        });
    }
    static isAutoMerging() {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_PATH + "/isAutoMerging");
        });
    }
}
